module.exports = __webpack_public_path__ + "img/zhinengzhizao_ximenzi.b9ac6f51.png";